// Final copy for the daily unlock cap (ONE-6862). Shown via SnackbarService.criticalAlt,
// which renders the <b> markup. Shared so every unlock surface shows identical copy.
export const UNLOCK_LIMIT_REACHED_TOAST =
  "<b>You've reached today's unlock limit.</b> More unlocks tomorrow!";
